export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE_C2C:'SET_FETCHED_QUESTIONS_TO_STATE_C2C',
    SET_SELECTED_QUESTION_C2C:'SET_SELECTED_QUESTION_C2C',
    SELECTED_QUESTION_NEXT_C2C:'SELECTED_QUESTION_NEXT_C2C',
    SELECTED_QUESTION_PREVIOUS_C2C:'SELECTED_QUESTION_PREVIOUS_C2C',
    SET_SELECTED_ANSWER_C2C:'SET_SELECTED_ANSWER_C2C',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}